

import Template6 from "../assets/images/Templates/template6.png";
import Template7 from "../assets/images/Templates/template7.png";
import Template8 from "../assets/images/Templates/template8.png";
import Template9 from "../assets/images/Templates/template9.png";
import Template5 from "../assets/images/Templates/template5.png";

export const TemplateDataLandscape = [
	Template6,
	Template7,
	Template8,
	Template9,
	Template5,
];

export default TemplateDataLandscape;
